import { catchRestError, RestClient } from "clients/rest";
import { B000ShokaKbn, getSCode } from "messages/codes";
import { UseFormReturn } from "react-hook-form";
import { calledParam } from "services/codes";
import { PageableResponse } from "../PageableResponse";

export type B000150FindRequest = Partial<{
  tokuiCdFrom: string;
  tokuishitenCdFrom: string;
  tokuiCdTo: string;
  tokuishitenCdTo: string;
  shokaKbn: string;
  name: string;
  torihikisakibun: string;
  tokuibunCd: string;
  calledParam: string;
  deljogaiKbn: string;
  torihikishuryoYmd: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000150FindResponse = {
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm1: string;
  tokuiNm2: string;
  tokuiKana: string;
  shainCd: string;
  tokuiKbn: string;
  tokuiNmr: string;
  postCd: string;
  address1: string;
  address2: string;
  telNo: string;
  faxNo: string;
  shokuchiKbn: string;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  seikyuKbn: string;
  seikyuCd: string;
  seikyushitenCd: string;
  urikakeKbn: string;
  urikakeCd: string;
  urikakeshitenCd: string;
  nonyuKbn: string;
  urikakeshainCd: string;
  tankaKakeritsu: string;
  tokuibunCd1: string;
  tokuibunCd2: string;
  tokuibunCd3: string;
  tokuibunCd4: string;
  tokuibunCd5: string;
  zeiKbn: string;
  zeimarumeKbn: string;
  zeihasuichi: string;
  kinmarumeKbn: string;
  kinhasuichi: string;
  shokaKbn: string;
  denpyoshubetsuCd: string;
  denpyogyosu: string;
  denpyoKbn: string;
  tenpudenpyoCd: string;
  ritsu: string;
  bunrui: string;
  torihikisakiCd: string;
  hyakatenCd: string;
  shutsuryokushohinCd: string;
  jodaihyojiKbn: string;
  unsogaishaCd: string;
  shimeD: string;
  kaishuyoteiM: string;
  kaishuyoteiD: string;
  seikyushoKbn: string;
  seikyushokeishikiKbn: string;
  seikyushosaibanKbn: string;
  seikyushoNo: string;
  kaishuKbn: string;
  itakusokoCd: string;
  shatenCd: string;
  kigyoCd: string;
  tenpoCd: string;
  tankamarumeKbn: string;
  tankahasuichi: string;
  kyakusakinoKbn: string;
  sakujoyoteiKbn: string;
};

export const B000150Find = (props: B000150FindRequest) => {
  return RestClient.get<PageableResponse<B000150FindResponse[]>>(
    "b000150/find",
    {
      params: props,
    }
  );
};

export type B000150GetRequest = {
  tokuiCd: string;
  tokuishitenCd: string;
} & Partial<{
  calledParam: string;
}>;

export const B000150Get = (props: B000150GetRequest) => {
  return RestClient.get("b000150/get", {
    params: props,
  });
};

//納入先照会用(フロント処理詳細2に該当する)の得意先名1と消化区分を取得するメソッド
export const B000150Tokui = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuiCd === "" || data.tokuishitenCd === "") {
    methods.setValue("tokuiNm", "");
    methods.setValue("shokaKbn", getSCode(B000ShokaKbn, "0"));
    return;
  }
  await B000150Get({ tokuiCd: data.tokuiCd, tokuishitenCd: data.tokuishitenCd })
    .then((response) => {
      if (response.data.tokuiKbn === 1) {
        methods.setValue("tokuiNm", response.data.tokuiNm1 ?? "");
        methods.setValue(
          "shokaKbn",
          getSCode(B000ShokaKbn, response.data.shokaKbn)
        );
      } else {
        methods.setValue("tokuiNm", "");
        methods.setValue("shokaKbn", "");
      }
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNm", "");
      methods.setValue("shokaKbn", getSCode(B000ShokaKbn, "0"));
    });
};

//得意先名表示(返却値は得意先マスタ.得意先名1)
export const B000150TokuiNm1 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuiCd === "" || data.tokuishitenCd === "") {
    methods.setValue("tokuiNm", "");
    return;
  }
  await B000150Get({ tokuiCd: data.tokuiCd, tokuishitenCd: data.tokuishitenCd })
    .then((response) => {
      methods.setValue("tokuiNm", response.data.tokuiNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNm", "");
    });
};

//得意先名表示(返却値は得意先マスタ.得意先略)
export const B000150TokuiNm2 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuiCd === "" || data.tokuishitenCd === "") {
    methods.setValue("tokuiNm", "");
    return;
  }
  await B000150Get({ tokuiCd: data.tokuiCd, tokuishitenCd: data.tokuishitenCd })
    .then((response) => {
      methods.setValue("tokuiNm", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNm", "");
    });
};

//得意先名略表示
export const B000150TokuiNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuiCd === "" || data.tokuishitenCd === "") {
    methods.setValue("tokuiNmr", "");
    return;
  }
  await B000150Get({ tokuiCd: data.tokuiCd, tokuishitenCd: data.tokuishitenCd })
    .then((response) => {
      methods.setValue("tokuiNmr", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNmr", "");
    });
};

//得意先名(From)取得メソッド
export const B000150TokuiNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuiCdFrom === "" || data.tokuishitenCdFrom === "") {
    methods.setValue("tokuiNmFrom", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.tokuiCdFrom,
    tokuishitenCd: data.tokuishitenCdFrom,
  })
    .then((response) => {
      methods.setValue("tokuiNmFrom", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNmFrom", "");
    });
};

//得意先名(To)表示
export const B000150TokuiNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuiCdTo === "" || data.tokuishitenCdTo === "") {
    methods.setValue("tokuiNmTo", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.tokuiCdTo,
    tokuishitenCd: data.tokuishitenCdTo,
  })
    .then((response) => {
      methods.setValue("tokuiNmTo", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNmTo", "");
    });
};

//納入先名表示
export const B000150NonyuNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.nonyuCd === "" || data.nonyushitenCd === "") {
    methods.setValue("nonyuNm", "");
    return;
  }
  await B000150Get({ tokuiCd: data.nonyuCd, tokuishitenCd: data.nonyushitenCd })
    .then((response) => {
      methods.setValue("nonyuNm", response.data.tokuiNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("nonyuNm", "");
    });
};

//納入先名表示(得意先マスタ.得意先名略を取得する場合)
export const B000150NonyuNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.nonyuCd === "" || data.nonyushitenCd === "") {
    methods.setValue("nonyuNm", "");
    return;
  }
  await B000150Get({ tokuiCd: data.nonyuCd, tokuishitenCd: data.nonyushitenCd })
    .then((response) => {
      methods.setValue("nonyuNm", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("nonyuNm", "");
    });
};

//納入先名(From)表示
export const B000150NonyuNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.nonyuCdFrom === "" || data.nonyushitenCdFrom === "") {
    methods.setValue("nonyuNmFrom", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.nonyuCdFrom,
    tokuishitenCd: data.nonyushitenCdFrom,
  })
    .then((response) => {
      methods.setValue("nonyuNmFrom", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("nonyuNmFrom", "");
    });
};

//納入先名(To)表示
export const B000150NonyuNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.nonyuCdTo === "" || data.nonyushitenCdTo === "") {
    methods.setValue("nonyuNmTo", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.nonyuCdTo,
    tokuishitenCd: data.nonyushitenCdTo,
  })
    .then((response) => {
      methods.setValue("nonyuNmTo", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("nonyuNmTo", "");
    });
};

//得意先名略表示(seikyuNmrにセット)
export const B000150SeikyuNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd === "" || data.seikyushitenCd === "") {
    methods.setValue("seikyuNmr", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd,
    tokuishitenCd: data.seikyushitenCd,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr", "");
    });
};

//得意先名略表示(urikakeNmrにセット)
export const B000150UrikakeNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.urikakeCd === "" || data.urikakeshitenCd === "") {
    methods.setValue("urikakeNmr", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.urikakeCd,
    tokuishitenCd: data.urikakeshitenCd,
    calledParam: calledParam.urikake,
  })
    .then((response) => {
      methods.setValue("urikakeNmr", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("urikakeNmr", "");
    });
};

//得意先名略表示(urikakeNmrFromにセット)
export const B000150UrikakeNmrFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.urikakeCdFrom === "" || data.urikakeshitenCdFrom === "") {
    methods.setValue("urikakeNmrFrom", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.urikakeCdFrom,
    tokuishitenCd: data.urikakeshitenCdFrom,
    calledParam: calledParam.urikake,
  })
    .then((response) => {
      methods.setValue("urikakeNmrFrom", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("urikakeNmrFrom", "");
    });
};

//得意先名略表示(urikakeNmrToにセット)
export const B000150UrikakeNmrTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.urikakeCdTo === "" || data.urikakeshitenCdTo === "") {
    methods.setValue("urikakeNmrTo", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.urikakeCdTo,
    tokuishitenCd: data.urikakeshitenCdTo,
    calledParam: calledParam.urikake,
  })
    .then((response) => {
      methods.setValue("urikakeNmrTo", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("urikakeNmrTo", "");
    });
};

//得意先名略表示(urikakeCdを用いてtokuiNmrにセット)
export const B000150TokuiNmrUrikakeCd = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.urikakeCd === "" || data.urikakeshitenCd === "") {
    methods.setValue("tokuiNmr", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.urikakeCd,
    tokuishitenCd: data.urikakeshitenCd,
    calledParam: data.torihikiKbn.value,
  })
    .then((response) => {
      methods.setValue("tokuiNmr", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNmr", "");
    });
};

//得意先名略表示(seikyuNmrFromにセット)
export const B000150SeikyuNmrFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCdFrom === "" || data.seikyushitenCdFrom === "") {
    methods.setValue("seikyuNmrFrom", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCdFrom,
    tokuishitenCd: data.seikyushitenCdFrom,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmrFrom", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmrFrom", "");
    });
};

//得意先名略表示(seikyuNmrToにセット)
export const B000150SeikyuNmrTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCdTo === "" || data.seikyushitenCdTo === "") {
    methods.setValue("seikyuNmrTo", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCdTo,
    tokuishitenCd: data.seikyushitenCdTo,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmrTo", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmrTo", "");
    });
};

//得意先名略表示(seikyuNmrFrom1にセット)
export const B000150SeikyuNmrFrom1 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCdFrom1 === "" || data.seikyushitenCdFrom1 === "") {
    methods.setValue("seikyuNmrFrom1", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCdFrom1,
    tokuishitenCd: data.seikyushitenCdFrom1,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmrFrom1", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmrFrom1", "");
    });
};

//得意先名略表示(seikyuNmrTo1にセット)
export const B000150SeikyuNmrTo1 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCdTo1 === "" || data.seikyushitenCdTo1 === "") {
    methods.setValue("seikyuNmrTo1", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCdTo1,
    tokuishitenCd: data.seikyushitenCdTo1,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmrTo1", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmrTo1", "");
    });
};

//得意先名略表示(seikyuNmrFrom2にセット)
export const B000150SeikyuNmrFrom2 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCdFrom2 === "" || data.seikyushitenCdFrom2 === "") {
    methods.setValue("seikyuNmrFrom2", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCdFrom2,
    tokuishitenCd: data.seikyushitenCdFrom2,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmrFrom2", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmrFrom2", "");
    });
};

//得意先名略表示(seikyuNmrTo2にセット)
export const B000150SeikyuNmrTo2 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCdTo === "" || data.seikyushitenCdTo2 === "") {
    methods.setValue("seikyuNmrTo2", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCdTo2,
    tokuishitenCd: data.seikyushitenCdTo2,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmrTo2", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmrTo2", "");
    });
};

//得意先名略表示(seikyuNmrFrom3にセット)
export const B000150SeikyuNmrFrom3 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCdFrom3 === "" || data.seikyushitenCdFrom3 === "") {
    methods.setValue("seikyuNmrFrom3", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCdFrom3,
    tokuishitenCd: data.seikyushitenCdFrom3,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmrFrom3", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmrFrom3", "");
    });
};

//得意先名略表示(seikyuNmrTo3にセット)
export const B000150SeikyuNmrTo3 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCdTo32 === "" || data.seikyushitenCdTo3 === "") {
    methods.setValue("seikyuNmrTo3", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCdTo3,
    tokuishitenCd: data.seikyushitenCdTo3,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmrTo3", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmrTo3", "");
    });
};

//得意先名略表示(seikyuNmrFrom4にセット)
export const B000150SeikyuNmrFrom4 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCdFrom4 === "" || data.seikyushitenCdFrom4 === "") {
    methods.setValue("seikyuNmrFrom4", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCdFrom4,
    tokuishitenCd: data.seikyushitenCdFrom4,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmrFrom4", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmrFrom4", "");
    });
};

//得意先名略表示(seikyuNmrTo4にセット)
export const B000150SeikyuNmrTo4 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCdTo4 === "" || data.seikyushitenCdTo4 === "") {
    methods.setValue("seikyuNmrTo4", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCdTo4,
    tokuishitenCd: data.seikyushitenCdTo4,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmrTo4", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmrTo4", "");
    });
};

//得意先名略表示(seikyuNmr1にセット)
export const B000150SeikyuNmr1 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd1 === "" || data.seikyushitenCd1 === "") {
    methods.setValue("seikyuNmr1", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd1,
    tokuishitenCd: data.seikyushitenCd1,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr1", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr1", "");
    });
};

//得意先名略表示(seikyuNmr2にセット)
export const B000150SeikyuNmr2 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd2 === "" || data.seikyushitenCd2 === "") {
    methods.setValue("seikyuNmr2", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd2,
    tokuishitenCd: data.seikyushitenCd2,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr2", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr2", "");
    });
};

//得意先名略表示(seikyuNmr3にセット)
export const B000150SeikyuNmr3 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd3 === "" || data.seikyushitenCd3 === "") {
    methods.setValue("seikyuNmr3", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd3,
    tokuishitenCd: data.seikyushitenCd3,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr3", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr3", "");
    });
};

//得意先名略表示(seikyuNmr4にセット)
export const B000150SeikyuNmr4 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd4 === "" || data.seikyushitenCd4 === "") {
    methods.setValue("seikyuNmr4", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd4,
    tokuishitenCd: data.seikyushitenCd4,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr4", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr4", "");
    });
};

//得意先名略表示(seikyuNmr5にセット)
export const B000150SeikyuNmr5 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd5 === "" || data.seikyushitenCd5 === "") {
    methods.setValue("seikyuNmr5", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd5,
    tokuishitenCd: data.seikyushitenCd5,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr5", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr5", "");
    });
};

//得意先名略表示(seikyuNmr6にセット)
export const B000150SeikyuNmr6 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd6 === "" || data.seikyushitenCd6 === "") {
    methods.setValue("seikyuNmr6", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd6,
    tokuishitenCd: data.seikyushitenCd6,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr6", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr6", "");
    });
};

//得意先名略表示(seikyuNmr7にセット)
export const B000150SeikyuNmr7 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd7 === "" || data.seikyushitenCd7 === "") {
    methods.setValue("seikyuNmr7", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd7,
    tokuishitenCd: data.seikyushitenCd7,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr7", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr7", "");
    });
};

//得意先名略表示(seikyuNmr8にセット)
export const B000150SeikyuNmr8 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd8 === "" || data.seikyushitenCd8 === "") {
    methods.setValue("seikyuNmr8", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd8,
    tokuishitenCd: data.seikyushitenCd8,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr8", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr8", "");
    });
};

//得意先名略表示(seikyuNmr9にセット)
export const B000150SeikyuNmr9 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd9 === "" || data.seikyushitenCd9 === "") {
    methods.setValue("seikyuNmr9", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd9,
    tokuishitenCd: data.seikyushitenCd9,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr9", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr9", "");
    });
};

//得意先名略表示(seikyuNmr10にセット)
export const B000150SeikyuNmr10 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd10 === "" || data.seikyushitenCd10 === "") {
    methods.setValue("seikyuNmr10", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd10,
    tokuishitenCd: data.seikyushitenCd10,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr10", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr10", "");
    });
};

//得意先名略表示(seikyuNmr11にセット)
export const B000150SeikyuNmr11 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd11 === "" || data.seikyushitenCd11 === "") {
    methods.setValue("seikyuNmr11", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd11,
    tokuishitenCd: data.seikyushitenCd11,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr11", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr11", "");
    });
};

//得意先名略表示(seikyuNmr12にセット)
export const B000150SeikyuNmr12 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd12 === "" || data.seikyushitenCd12 === "") {
    methods.setValue("seikyuNmr12", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd12,
    tokuishitenCd: data.seikyushitenCd12,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr12", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr12", "");
    });
};

//得意先名略表示(seikyuNmr13にセット)
export const B000150SeikyuNmr13 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd13 === "" || data.seikyushitenCd13 === "") {
    methods.setValue("seikyuNmr13", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd13,
    tokuishitenCd: data.seikyushitenCd13,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr13", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr13", "");
    });
};

//得意先名略表示(seikyuNmr14にセット)
export const B000150SeikyuNmr14 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd14 === "" || data.seikyushitenCd14 === "") {
    methods.setValue("seikyuNmr14", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd14,
    tokuishitenCd: data.seikyushitenCd14,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr14", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr14", "");
    });
};

//得意先名略表示(seikyuNmr15にセット)
export const B000150SeikyuNmr15 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd15 === "" || data.seikyushitenCd15 === "") {
    methods.setValue("seikyuNmr15", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd15,
    tokuishitenCd: data.seikyushitenCd15,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr15", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr15", "");
    });
};

//得意先名略表示(seikyuNmr16にセット)
export const B000150SeikyuNmr16 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd16 === "" || data.seikyushitenCd16 === "") {
    methods.setValue("seikyuNmr16", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd16,
    tokuishitenCd: data.seikyushitenCd16,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr16", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr16", "");
    });
};

//得意先名略表示(seikyuNmr17にセット)
export const B000150SeikyuNmr17 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd17 === "" || data.seikyushitenCd17 === "") {
    methods.setValue("seikyuNmr17", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd17,
    tokuishitenCd: data.seikyushitenCd17,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr17", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr17", "");
    });
};

//得意先名略表示(seikyuNmr18にセット)
export const B000150SeikyuNmr18 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd18 === "" || data.seikyushitenCd18 === "") {
    methods.setValue("seikyuNmr18", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd18,
    tokuishitenCd: data.seikyushitenCd18,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr18", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr18", "");
    });
};

//得意先名略表示(seikyuNmr19にセット)
export const B000150SeikyuNmr19 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd19 === "" || data.seikyushitenCd19 === "") {
    methods.setValue("seikyuNmr19", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd19,
    tokuishitenCd: data.seikyushitenCd19,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr19", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr19", "");
    });
};

//得意先名略表示(seikyuNmr20にセット)
export const B000150SeikyuNmr20 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCd20 === "" || data.seikyushitenCd20 === "") {
    methods.setValue("seikyuNmr20", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCd20,
    tokuishitenCd: data.seikyushitenCd20,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmr20", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmr20", "");
    });
};

//得意先名略表示(seikyuNmFromにセット)
export const B000150SeikyuNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCdFrom === "" || data.seikyushitenCdFrom === "") {
    methods.setValue("seikyuNmFrom", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCdFrom,
    tokuishitenCd: data.seikyushitenCdFrom,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmFrom", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmFrom", "");
    });
};

//得意先名略表示(seikyuNmToにセット)
export const B000150SeikyuNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.seikyuCdTo === "" || data.seikyushitenCdTo === "") {
    methods.setValue("seikyuNmTo", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.seikyuCdTo,
    tokuishitenCd: data.seikyushitenCdTo,
    calledParam: calledParam.seikyu,
  })
    .then((response) => {
      methods.setValue("seikyuNmTo", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("seikyuNmTo", "");
    });
};

// 得意先名力表示(torihikiNmにセット)
export const B000150TorihikiNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.torihikiCd === "" || data.torihikishitenCd === "") {
    methods.setValue("torihikiNm", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.torihikiCd,
    tokuishitenCd: data.torihikishitenCd,
  })
    .then((response) => {
      methods.setValue("torihikiNm", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("torihikiNm", "");
    });
};

// 得意先名表示(torihikiNmFromにセット)
export const B000150TorihikiNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.torihikiCdFrom === "" || data.torihikishitenCdFrom === "") {
    methods.setValue("torihikiNmFrom", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.torihikiCdFrom,
    tokuishitenCd: data.torihikishitenCdFrom,
  })
    .then((response) => {
      methods.setValue("torihikiNmFrom", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("torihikiNmFrom", "");
    });
};

// 得意先名表示(torihikiNmToにセット)
export const B000150TorihikiNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.torihikiCdTo === "" || data.torihikishitenCdTo === "") {
    methods.setValue("torihikiNmTo", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.torihikiCdTo,
    tokuishitenCd: data.torihikishitenCdTo,
  })
    .then((response) => {
      methods.setValue("torihikiNmTo", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("torihikiNmTo", "");
    });
};

//得意先名(From)取得メソッド
export const B000150TokuiNm1From = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuiCdFrom === "" || data.tokuishitenCdFrom === "") {
    methods.setValue("tokuiNmFrom", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.tokuiCdFrom,
    tokuishitenCd: data.tokuishitenCdFrom,
  })
    .then((response) => {
      methods.setValue("tokuiNmFrom", response.data.tokuiNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNmFrom", "");
    });
};

//得意先名(To)取得メソッド
export const B000150TokuiNm1To = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuiCdTo === "" || data.tokuishitenCdTo === "") {
    methods.setValue("tokuiNmTo", "");
    return;
  }
  await B000150Get({
    tokuiCd: data.tokuiCdTo,
    tokuishitenCd: data.tokuishitenCdTo,
  })
    .then((response) => {
      methods.setValue("tokuiNmTo", response.data.tokuiNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNmTo", "");
    });
};
